module.exports = __webpack_public_path__ + "static/fonts/Oxanium-ExtraBold.66283640.ttf";